import { render, staticRenderFns } from "./ClinicalReports.vue?vue&type=template&id=36ae84bf&scoped=true"
import script from "./ClinicalReports.vue?vue&type=script&lang=js"
export * from "./ClinicalReports.vue?vue&type=script&lang=js"
import style0 from "./ClinicalReports.vue?vue&type=style&index=0&id=36ae84bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae84bf",
  null
  
)

export default component.exports